
import { LoadingOutlined } from '@ant-design/icons';
import { DropdownItem, DropdownItemStatusIcon, DropdownItemStatusIconWrapper, DropdownList, DropdownListWrapper, LoadingIconWrapper, VaultUploadedFileBoxDescriptionSizeWrapper, VaultUploadedFileBoxDescriptionSizeWrapperDot, DocumentDetailsWrapper, DocumentIconWrapper, DocumentSize, DocumentTitle } from './DeepAnalysisReviewResultModal.styles';
import { CircleStatusIcon } from '../../assets/icons';
import { observer } from 'mobx-react';
import { VaultTooltip } from '../../utils/Utils';
import { getFileSizeString, getFileType } from '../../utils/Utils';

export const FilesDropdown = observer(({ files: filesInReview }) => {
 
    return (
        <DropdownListWrapper>
            <DropdownList>
                {filesInReview.map((file, index) => {
                    const isInProcess = file.llmStatus === 'in process';
                    const isDone = file.llmStatus === 'done';
                    const hasResult = Boolean(file.llmResultMetadata?.llmResultURL);

                    const isReady = isDone && hasResult;
                    const isLoading = isInProcess || (isDone && !hasResult);

                    return (

                        <DropdownItem key={index}>
                            <DocumentIconWrapper>{getFileType(file.originalName)}</DocumentIconWrapper>
                            <DocumentDetailsWrapper>
                                <DocumentTitle>{file.originalName}</DocumentTitle>
                                <VaultUploadedFileBoxDescriptionSizeWrapper>
                                    <DocumentSize>{getFileSizeString(file.size)}</DocumentSize>
                                    {
                                        file.llmDescription &&
                                        <VaultTooltip title={file.llmDescription}>
                                            <VaultUploadedFileBoxDescriptionSizeWrapperDot>{file.llmDescription}</VaultUploadedFileBoxDescriptionSizeWrapperDot>
                                        </VaultTooltip>
                                    }
                                </VaultUploadedFileBoxDescriptionSizeWrapper>
                            </DocumentDetailsWrapper>
                            <DropdownItemStatusIconWrapper >
                                {isLoading ?
                                    <LoadingIconWrapper>
                                        <LoadingOutlined style={{ fontSize: '24px' }} />
                                    </LoadingIconWrapper> :
                                    <VaultTooltip title={(file.llmStatus === 'done' ? READY_FILE_TEXT : FAILED_FILE_TEXT)}>
                                        <DropdownItemStatusIcon isReady={isReady}>
                                            <div><CircleStatusIcon /></div>
                                            <div>{(isReady) ? 'Ready for review' : 'In deep analysis'}</div>
                                        </DropdownItemStatusIcon>
                                    </VaultTooltip>
                                }
                            </DropdownItemStatusIconWrapper>
                        </DropdownItem>
                    )
                })}
            </DropdownList>
        </DropdownListWrapper>
    )
});

const READY_FILE_TEXT = `
  Vault AI has found new assets or liabilities in this file.

  You can review the results and add them to your portfolio.
`;

const FAILED_FILE_TEXT = `
  Vault AI couldn’t generate initial results for this file.

  We’re running a deeper analysis to identify relevant data and update your portfolio.
`;